import { render, staticRenderFns } from "./AmendmentIcon.vue?vue&type=template&id=1c3d7394&"
import script from "./AmendmentIcon.vue?vue&type=script&lang=js&"
export * from "./AmendmentIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports